exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-age-child-select[data-v-c52a9ffe]{width:84px}.wrap-age-child-select[data-v-c52a9ffe] .select-list{height:200px}.pl-12[data-v-c52a9ffe]{padding-left:3rem!important}.user-icon[data-v-c52a9ffe]{position:absolute;top:50%;left:15px;transform:translateY(-50%)}.done-btn[data-v-c52a9ffe]{padding:0 2rem;min-width:42px}.note-text[data-v-c52a9ffe]{color:var(--error-primary);font-size:14px}.select-list[data-v-c52a9ffe]{max-height:600px;overflow-y:auto}.custom-select-input[data-v-c52a9ffe]{width:300px}@media(max-width:600px){.custom-select-input[data-v-c52a9ffe]{width:100%}}", ""]);

// exports
